import { render, staticRenderFns } from "./Relation.vue?vue&type=template&id=03173466"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports